import { createPullstateCore } from 'pullstate';

import { AlertsStore } from './stores/alerts';
import { RequestsStore } from './stores/requests';
import { SessionStore } from './stores/session';

export const PullstateCore = createPullstateCore({
  AlertsStore,
  RequestsStore,
  SessionStore,
});
